import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

interface ActionKeyState {
  expiredAt: number;
  actionPublicKey: string;
  actionPrivateKey: string;

  setActionKey: (expiredAt: number, actionPublicKey: string, actionPrivateKey: string) => void;
}

const useActionKeyStore = create<ActionKeyState>()(
  devtools(
    set => ({
      expiredAt: 0,
      actionPublicKey: '',
      actionPrivateKey: '',

      setActionKey: (expiredAt: number, actionPublicKey: string, actionPrivateKey: string) =>
        set({ expiredAt: expiredAt, actionPublicKey: actionPublicKey, actionPrivateKey: actionPrivateKey }),
    }),
    {
      name: 'action-key-store',
    },
  ),
);

export default useActionKeyStore;
